import { render, staticRenderFns } from "./IcmsDifal.vue?vue&type=template&id=5ff1b71a&scoped=true&"
import script from "./IcmsDifal.vue?vue&type=script&lang=js&"
export * from "./IcmsDifal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff1b71a",
  null
  
)

export default component.exports